/**
 * Conservative free-text write intent detector for chat consultationMode flip.
 * Requires action-shaped phrasing; question-form inputs are excluded.
 */
export function isWriteIntent(text) {
  if (!text || typeof text !== "string") return false;
  const t = text.trim();
  if (t.length < 8) return false;

  if (/^(how|what|why|when|where|can|could|should|would|do|does|is|are)\b/i.test(t)) return false;

  if (/\bsearch\b/i.test(t)) return true;
  if (/\bintegrate\b/i.test(t)) return true;
  if (/\bconfigure\s+(?:an?\s+)?application\b/i.test(t)) return true;

  const writeVerbEntity =
    /\b(create|add|delete|remove|deactivate|disable|enable|demote|promote)\s+(?:an?\s+|the\s+)?(group|user|app|application|policy|rule|zone|authenticator|role|admin)\b/i;
  if (writeVerbEntity.test(t)) return true;

  return false;
}
